<main class="shell">
  <section class="workspace">
    <aside class="panel">
      <div class="brand">
        <span class="brand-mark">V</span>
        <div>
          <p>vdoCipher DRM</p>
          <strong>Token Broker POC</strong>
        </div>
      </div>

      <form class="create-form" (ngSubmit)="importAsset()">
        <label>
          Title
          <input
            name="title"
            [(ngModel)]="newTitle"
            placeholder="Premium course episode"
          />
        </label>
        <label>
          Source URL
          <input
            name="sourceUrl"
            [(ngModel)]="newSourceUrl"
            placeholder="https://storage.example.com/video.mp4"
          />
        </label>
        <label>
          Folder ID
          <input
            name="folderId"
            [(ngModel)]="newFolderId"
            placeholder="root"
          />
        </label>
        <div class="form-section">
          <label>
            Video File
            <input
              name="videoFile"
              type="file"
              accept="video/*"
              (change)="onUploadFileSelected($event)"
            />
          </label>
          @if (selectedUploadFile) {
            <small>{{ selectedUploadFile.name }}</small>
          }
          @if (uploadProgress() !== null) {
            <div class="upload-progress">
              <progress [value]="uploadProgress() ?? 0" max="100"></progress>
              <span>{{ uploadProgress() }}%</span>
            </div>
          }
          <button
            type="button"
            (click)="uploadAsset()"
            [disabled]="busy() || !newTitle || !selectedUploadFile"
          >
            Upload file
          </button>
        </div>
        <div class="form-section">
          <button type="submit" [disabled]="busy() || !newTitle || !newSourceUrl">
            Import URL
          </button>
        </div>
      </form>

      <div class="asset-list">
        @for (asset of assets(); track asset.id) {
          <button
            class="asset-row"
            type="button"
            [class.active]="selectedAsset()?.id === asset.id"
            [class.pending]="!asset.ready"
            (click)="selectAsset(asset)"
          >
            <span>{{ asset.title }}</span>
            <small
              >{{ asset.status }} ·
              {{
                asset.lastErrorMessage
                  ? 'error'
                  : asset.ready
                    ? 'playable'
                    : 'needs sync'
              }}</small
            >
          </button>
        } @empty {
          <p class="empty">
            No assets yet. Upload a local video or import a reachable MP4 URL,
            then sync it after vdoCipher finishes processing it.
          </p>
        }
      </div>
    </aside>

    <section class="stage">
      <header>
        <div>
          <p class="eyebrow">Token brokered playback</p>
          <h1>{{ selectedAsset()?.title || 'No asset selected' }}</h1>
        </div>
        <div class="header-actions">
          @if (selectedAsset()) {
            <button
              type="button"
              class="danger"
              (click)="deleteSelectedAsset()"
              [disabled]="busy()"
            >
              Delete asset
            </button>
          }
          <button type="button" (click)="refresh()" [disabled]="busy()">
            {{ busy() ? 'Working...' : 'Refresh' }}
          </button>
        </div>
      </header>

      <div class="status-strip" [class.waiting]="selectedAsset() && !selectedAsset()?.ready">
        <span>{{ statusMessage() }}</span>
        <strong>{{ apiBaseUrl }}</strong>
      </div>

      <div class="playback-controls">
        <label>
          Watermark content
          <input
            name="watermarkText"
            [(ngModel)]="watermarkText"
            placeholder="Demo User 01"
          />
        </label>
        <div class="playback-actions">
          <button
            type="button"
            (click)="applyWatermark()"
            [disabled]="busy() || !selectedAsset()?.ready"
          >
            Apply watermark
          </button>
          <button
            type="button"
            class="secondary"
            (click)="clearWatermark()"
            [disabled]="busy() || !selectedAsset()?.ready"
          >
            Clear watermark
          </button>
        </div>
      </div>

      <div class="player-frame">
        @if (playbackUrl(); as url) {
          <iframe
            [src]="url"
            title="vdoCipher DRM player"
            allow="encrypted-media"
            allowfullscreen
          ></iframe>
          @if (appliedWatermarkText) {
            <div class="watermark-overlay" aria-hidden="true">
              {{ appliedWatermarkText }}
            </div>
          }
        } @else {
          <div class="placeholder">
            <strong>{{ placeholderTitle() }}</strong>
            <span>{{ helperText() }}</span>
            @if (selectedAsset() && !selectedAsset()?.ready) {
              <button
                type="button"
                (click)="syncSelectedAsset()"
                [disabled]="busy()"
              >
                Sync asset
              </button>
            }
            @if (selectedAsset()?.ready) {
              <button
                type="button"
                (click)="requestSelectedPlayback()"
                [disabled]="busy()"
              >
                Request token again
              </button>
            }
          </div>
        }
      </div>

      <div class="facts">
        <div>
          <span>Video ID</span>
          <strong>{{ selectedAsset()?.vdocipherVideoId || '-' }}</strong>
        </div>
        <div>
          <span>OTP Expiry</span>
          <strong>{{ playback()?.expiresAt || '-' }}</strong>
        </div>
        <div>
          <span>Poster</span>
          <strong>{{ selectedAsset()?.posterUrl || '-' }}</strong>
        </div>
        <div>
          <span>Asset Status</span>
          <strong>{{ selectedAsset()?.status || '-' }}</strong>
        </div>
        <div>
          <span>Applied Watermark</span>
          <strong>{{ appliedWatermarkText || '-' }}</strong>
        </div>
      </div>

      @if (selectedAsset()?.lastErrorMessage) {
        <p class="asset-error">
          {{ selectedAsset()?.lastErrorCode }}:
          {{ selectedAsset()?.lastErrorMessage }}
        </p>
      }

      @if (error()) {
        <p class="error">{{ error() }}</p>
      }
    </section>
  </section>
</main>
